<template>
  <div class="goods-info">
    <div class="header">
      {{ goodsInfo.goodsName }}
    </div>
    <div class="content">
      <div class="order-code">
        <span class="label">订单编号:</span>
        <span class="text">{{ goodsInfo.goodsOrderCode }}</span>
      </div>
      <div class="order-time" :class="{ clearBottom: isDetail }">
        <span class="label">购买时间:</span>
        <span class="text">{{ formatTime(goodsInfo.goodsOrderTime) }}</span>
      </div>

      <div v-if="!isDetail" class="split-line"></div>
      <div v-if="!isDetail" class="order-money">
        <span class="label"> 开票金额: </span>
        <span class="money"
          >¥{{ transformMoney(goodsInfo.goodsInvoiceAmount) }}</span
        >
        <img
          class="tips-icon"
          src="https://res.pandateacher.com/9A45AV7C1631962088311.png"
          alt=""
          @click="handleConfirm"
        />
      </div>
    </div>
    <ApplyConfirm
      v-model="showApplyComfirm"
      @cancelApply="cancelApply"
      @confirmApply="confirmApply"
    >
      <template slot="title"> 开具金额 </template>
      <template slot="content">
        <ul class="ul">
          <li class="li-item">
            开票金额为实付金额，优惠券、补贴等不再开票范围内
          </li>
          <li class="li-item">
            如订单发生退款，开票金额将变更为最终实付金额，即实付金额-已退款金额
          </li>
        </ul>
      </template>
    </ApplyConfirm>
  </div>
</template>

<script lang="ts">
import { Prop, Component } from 'vue-property-decorator';
import ApplyConfirm from '../components/apply/components/ApplyConfirm.vue';
import BillingSystemMixins from '../mixin/mixins';
import { IGoodsInfo } from '../billingSystem';

@Component({
  components: {
    ApplyConfirm,
  },
})
export default class GoodsInfo extends BillingSystemMixins {
  @Prop({
    type: Object,
    default: () => {
      return {
        goodsName: '',
        goodsOrderCode: '',
        goodsOrderTime: 0,
        goodsOrderMoney: 0,
      };
    },
  })
  goodsInfo!: IGoodsInfo;
  @Prop({
    type: Boolean,
    default: false,
  })
  isDetail!: boolean;

  showApplyComfirm: Boolean = false;
  handleConfirm() {
    this.showApplyComfirm = true;
  }
  cancelApply() {
    this.showApplyComfirm = false;
  }
  confirmApply() {
    this.showApplyComfirm = false;
  }
}
</script>

<style lang="scss" scoped>
.goods-info {
  padding: 40px 32px;
  color: rgba(16, 16, 16, 100);
  background: #ffffff;
  border-radius: 16px;
}
.header {
  margin-bottom: 16px;
  color: #31285d;
  font-weight: 500;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
}
.order-code,
.order-time,
.order-money {
  margin-bottom: 16px;
  .label {
    margin-right: 8px;
    color: #ada9be;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .text {
    color: #6e688d;
    font-weight: 500;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .money {
    color: #31285d;
    font-weight: 500;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .tips-icon {
    display: inline-block;
    width: 44px;
    height: 44px;
    margin-left: 8px;
    vertical-align: bottom;
  }
}
.order-money {
  display: flex;
  align-items: center;
}
.order-time.clearBottom {
  margin-bottom: 0;
}
.order-money {
  margin-bottom: 0;
}
.split-line {
  height: 1px;
  margin-top: 24px;
  margin-bottom: 34px;
  background: #e5e3ec;
}
.ul {
  padding: 32px;
  list-style: unset;
  .li-item {
    margin-bottom: 24px;
    color: #6e688d;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 48px;
  }
}
</style>